import {
    Directive,
    OnInit,
    HostBinding,
    HostListener,
    Output,
    EventEmitter
} from '@angular/core';

const DARWIN_APP = 'screeps_server.app';
const WIN32_APP = 'screeps_server.exe';
const LINUX_APP = 'screeps_server';

const nw = window.nw;

let process_running = false;
@Directive({
    selector: '[serverStart]'
})
export class ServerStartDirective implements OnInit {
    public dirname = '';

    @Output() serverStart: EventEmitter<void> = new EventEmitter();
    @Output() serverClose: EventEmitter<void> = new EventEmitter();

    @HostBinding('class.--disabled') disabled: boolean = process_running;

    @HostListener('click', ['$event'])
    onClick($event) {
        $event.stopPropagation();

        const cp = nw.require('child_process');
        const path = nw.require('path');

        const options = {
            cwd: this.dirname,
            detached: true
        };

        let process;
        if (nw.process.platform === 'darwin') {
            process = cp.spawn('open', [path.resolve(this.dirname, DARWIN_APP)], options);
        }

        if (nw.process.platform === 'win32') {
            process = cp.spawn(path.resolve(this.dirname, WIN32_APP), options);
        }

        if (nw.process.platform === 'linux') {
            process = cp.spawn(path.resolve(this.dirname, LINUX_APP), ['--no-sandbox', '--ozone-platform=x11'], options);
        }

        this.disabled = process_running = true;
        process.on('close', () => {
            this.disabled = process_running = false;
            this.serverClose.emit();
        });

        this.serverStart.emit();
    }

    constructor() {
        try {
            const fs = nw.require('fs');
            const path = nw.require('path');

            this.dirname = path.resolve(path.dirname(nw.process.execPath).replace(/\/nwjs\.app.*$/, ''), 'server');

            fs.statSync(this.dirname);
        } catch (e) {
            // Noop.
        }
    }

    ngOnInit() {
    }
}
